import { render, staticRenderFns } from "./oppositeCompany.vue?vue&type=template&id=116baad4&"
import script from "./oppositeCompany.vue?vue&type=script&lang=js&"
export * from "./oppositeCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports